import React from 'react'
import styled from '@emotion/styled'
import Ajanlatkeres from '../containers/Ajanlatkeres'

const Main = styled.main`
  margin-top: 70px;
  line-height: 1.5rem;
`

const Title = styled.h2`
  padding-top: 90px;
  margin-top: -80px;
  font-weight: 200;
  color: #275236;

  @media (min-width: 64em) {
    font-size: 2.5rem;
  }
`

const SubTitle = styled.h3`
  padding-top: 90px;
  margin-top: -80px;
  font-weight: 200;
  color: #275236;

  @media (min-width: 64em) {
    font-size: 2rem;
  }
`

const Section = styled.section`
  position: relative;
  padding: 0 1rem;
  padding-bottom: 8px;
  margin: 2rem 0;

  a {
    text-decoration: none;
    color: initial;
  }

  ul {
    list-style: circle;

    li {
      margin: 0.5rem 0;

      a:after {
        content: ' ›';
      }
    }
  }

  &:first-of-type {
    margin-bottom: 4rem;
  }

  &:nth-of-type(2n) {
    background: linear-gradient(transparent 80px, rgba(39, 82, 54, 0.2) 80px, rgba(39, 82, 54, 0.2) 100%);

    ${SubTitle} {
      // color: #fff;
    }

    &:before {
      display: block;
      content: '';
      left: 0;
      position: absolute;
      top: calc(80px - 2rem);
      width: 100%;
      height: 2rem;
      background: linear-gradient(to right top, rgba(39, 82, 54, 0.2) 49.5%, transparent 50%);
    }

    &:after {
      display: block;
      content: '';
      left: 0;
      position: absolute;
      bottom: -2rem;
      width: 100%;
      height: 2rem;
      background: linear-gradient(to left bottom, rgba(39, 82, 54, 0.2) 49.5%, transparent 50%);
    }
  }

  @media (min-width: 64em) {
    p,
    ul,

    ${Title}, ${SubTitle} {
      margin: 2rem auto;
      max-width: 960px;
    }

    &:nth-of-type(2n) {
      &:before {
        top: calc(80px - 4rem);
        height: 4rem;
      }

      &:after {
        bottom: -4rem;
        height: 4rem;
      }
    }
  }
`

const Images = styled.section`
  overflow-y: hidden;
  overflow-x: scroll;
  -webkit-overflow-scrolling: touch;
  height: 320px;
  margin: 0 -1rem;
  width: calc(100% + 2rem);
  display: flex;
  flex-direction: row;

  img {
    flex: 1;
    display: block;
    height: 100%;
  }

  img + img {
    margin-left: 5px;
  }

  @media (min-width: 64em) {
    overflow-x: auto;
    margin: 0 auto;
    max-width: 1540px;
    height: auto;
    flex-wrap: wrap;

    img {
      flex: 1;
      display: block;
      width: 30%;
      // height: auto;
      margin: 5px;
    }
  }
`

const ScrollIndicator = styled.span`
  text-align: center;
  width: 100%;
  display: block;
  font-size: 0.8rem;
  position: absolute;
  bottom: 0.5rem;
  left: 0;
  color: #fff;

  @media (min-width: 64em) {
    display: none;
  }
`

export default () => (
  <div>
    <Main>
      <Section>
        <Title>Bádogos munkák</Title>
        <p>Két fajta bádogozási munkáról beszélünk: Tetőbádogozás és épületbádogozás.</p>
        <p>
          Vállalunk teljes körű tető és épületbádogozást, igény szerint fémlemez-, cserepes lemezfedés kivitelezését.
        </p>
        <p>
          Tetőszerkezet vagy épületszerkezet csatlakozási pontjainál fontos a vízmentesség, illetve hogy a
          csapadékelvezetés kellő szakértelemmel alakítsuk ki. Vállaljuk ablakpárkányok, kémény és falszegélyek, függő
          és fekvőeresz csatornák, orom, és ereszszegélyek kialakítását. Emellett lefolyók, vízgyűjtők, vápák,
          hattyúnyak, kiköpők, hajlatbádogok, véglemezek, szegletdíszek, tetőkibúvók, világító ablakok kivitelezését.
          Ezen kívül foglalkozunk egyéb bádogos szerkezetek javításával. Vállaljuk új szerkezetek kialakítását,
          gyártását és beépítését. Műdíszbádogok leszerelését, restaurálását, visszahelyezését. A bádogozáskor használt
          lemezek lehetnek a mai kórnak megfelelően, horganylemezből, alumíniumból, horganyzott acéllemezből vagy
          vörösrézből, de újabban már korszerű ötvözeteket alucink, titáncink, lakkozott termékeket is használunk. A
          fémlemezeket korcolással, szegezéssel, szegecseléssel vagy forrasztással rögzítjük egymáshoz. Ritka esetben
          ragasztással rögzítjük az aljszerkezethez. Az épület szegélyeinek bádogozása során oda kell figyelni, mert a
          rosszul kialakított vízorr miatt a csapadék a falra folyhat és ott a vakolaton kárt okoz. Szintén a
          bádogozással készülhetnek a homlokzatburkolatok, csővezetékek borításai, illetve a szellőzés berendezéseinek a
          csövei. A tetőszerkezeten leginkább a szegélyek, vápák, függőereszek, fekvőereszek, lefolyók, lemezfedések
          bádogozása látványos és fontos munkafolyamat. Ezek a szerkezetek a tetőfedést egészítik ki. A homlokzati
          párkány kifedések, ablakpárkányok, timpanon kifedések, cseppentő szegélyek is bádogos feladatok, melyeket
          teljeskörűen vállalunk!
        </p>
        <p>Szolgáltatásunk:</p>
        <ul>
          <li>ereszcsatorna készítése, javítása </li>
          <li>műemlék bádogozás </li>
          <li>bádog kifedések </li>
          <li>ereszszegély</li>
          <li>orom, falszegélyezés</li>
          <li>kéményszegélyezés</li>
          <li>párkányozás </li>
          <li>lemez, trapézlemez, cserepeslemez kivitelezése</li>
          <li>hófogó elhelyezése</li>
          <li>kéményseprő járda elhelyezése</li>
          <li>átvezetések bádogozás</li>
          <li>műdíszbádogozás</li>
        </ul>
      </Section>
      <Section>
        <SubTitle>Bádogos szerkezetek ellenőrzése, karbantartása</SubTitle>
        <p>
          A bádogos szerkezetek egyik hátránya, hogy a hőingadozás következtében folyamatosan mozognak, emiatt a
          toldások elrepedhetnek, ahol lehetséges korcolást vagy dilatációs szalag elhelyezést kell alkalmazni. Mozgás
          következtében az elemek csavarodhatnak, deformálódhatnak a rögzítések meglazulhatnak. Eresz,
          fekvőereszcsatornák, vápák esetén előfordulhat például, hogy a csatlakozásoknál idővel megrepednek a
          forrasztások, szétcsúsznak az elemek. Erre utalhat esős időben a csöpögő eresz, illetve a beázás. A tető és
          bádogos szerkezetek karbantartása nem csak a tetőszerkezetre korlátozódik. Oda kell figyelnünk a tetőhöz közel
          nőtt fákra is. Az ágakat, időben vágjuk vissza. A tetőhöz közeli vagy a tetőre nőtt ágak viharos időben
          lesodorhatják a cserepet a tetőről, így komoly sérüléseket okozhatnak a tetőszerkezetben. A leeső cserép
          életveszélyt okozhat!A jó karbantartás terhe a tulajdonoson van, esetleges személyi sérülés esetén a
          tulajdonos a felelős!. A tető fölé nyúló lombrészről ősszel lehulló levelek pedig gyorsan eltömíthetik,
          eldugítják az ereszcsatornát, nem beszélve arról, hogy belefagy, jégcsapképződést okozhat vagy rossz állapot
          esetén leszakadást.
        </p>
      </Section>
      <Ajanlatkeres />
    </Main>
  </div>
)
